/* ============================================================
   DIMA "Keeps of HAIR" quiz — results page V2 (Keeps-style redesign)
   Loaded by sections/hair-bundle-script-v2.liquid on the v2 quiz page.
   Same architecture as dima-bundle-results.js: sits on the host page,
   polls for the RevenueHunt quiz object, shows the quiz while in
   progress, and takes over rendering at results mode.
   Pricing/logic mirror: per-product tiers, minox 3mo max & no discount,
   free shipping >= 2500, Finasteride locked on male path.
   TODO before go-live: STAGE_PHOTOS urls (Higgsfield set).
   ============================================================ */
(function() {
  "use strict";

  if (!document.querySelector("link[href*='DM+Sans']")) {
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&family=Playfair+Display:wght@700;900&display=swap";
    document.head.appendChild(link);
  }

  /* ?retake=1 — clears the saved quiz session and restarts (useful on mobile
     where there is no easy way to clear localStorage). */
  try {
    if (/[?&]retake\b/.test(location.search)) {
      Object.keys(localStorage).forEach(function(k){ if (/^revenuehunt-/i.test(k)) localStorage.removeItem(k); });
      location.replace(location.pathname); // reload clean — storage is cleared before the app boots
    }
  } catch(e) {}

  function renderHeader() {
    return '<div class="db-header"><a class="db-retake">Retake Quiz</a><div class="db-logo">DIMA<span>.</span></div><span style="width:76px"></span></div>';
  }
  function attachRetake(root) {
    var r = root.querySelector(".db-retake");
    if (!r) return;
    r.addEventListener("click", function() {
      try { Object.keys(localStorage).forEach(function(k){ if (/^revenuehunt-/i.test(k)) localStorage.removeItem(k); }); } catch(e) {}
      location.replace(location.pathname); // fresh navigation so the quiz re-boots without saved answers
    });
  }

  var STYLE = document.createElement("style");
  STYLE.id = "dima-v2-style";
  STYLE.textContent = `#dima-bundle-root{--blue:#2563EB;--blue-dark:#1d4fc4;--navy:#0A1628;--ink:#101010;--grey:#57607A;--line:#E6E9F0;--tint:#EEF3FE;--tint2:#F7F9FD;--green:#12874a;--green-bg:#E7F6EE;font-family:'DM Sans',sans-serif;color:var(--ink);background:#fff;max-width:680px;margin:0 auto;padding:0 16px 24px;line-height:1.5;-webkit-font-smoothing:antialiased}
#dima-bundle-root *{box-sizing:border-box;margin:0;padding:0;font-family:'DM Sans',sans-serif}
#dima-bundle-root .db-eyebrow{letter-spacing:.14em;text-transform:uppercase;font-size:12px;font-weight:700;color:var(--blue)}
#dima-bundle-root h1,#dima-bundle-root h2{font-weight:800;letter-spacing:-.02em;color:var(--navy)}
#dima-bundle-root h1{font-size:clamp(30px,5vw,42px);line-height:1.08}
#dima-bundle-root h2{font-size:clamp(22px,3.6vw,28px);line-height:1.15}
#dima-bundle-root .db-sub{color:var(--grey);font-size:16px;line-height:1.55}
#dima-bundle-root .db-header{display:flex;align-items:center;justify-content:space-between;padding:18px 0;border-bottom:1px solid var(--line)}
#dima-bundle-root .db-logo{font-family:'Playfair Display',serif;font-weight:900;font-size:26px;color:var(--navy)}
#dima-bundle-root .db-logo span{color:var(--blue)}
#dima-bundle-root .db-retake{color:var(--blue);font-weight:600;font-size:14px;text-decoration:none;cursor:pointer}
#dima-bundle-root .db-hero{text-align:center;padding:36px 0 8px}
#dima-bundle-root .db-check{width:64px;height:64px;border-radius:50%;background:var(--tint);display:flex;align-items:center;justify-content:center;margin:0 auto 18px;color:var(--blue);font-size:28px;font-weight:800}
#dima-bundle-root .db-hero .db-eyebrow{display:block;margin-bottom:10px}
#dima-bundle-root .db-hero .db-sub{max-width:460px;margin:12px auto 0}
#dima-bundle-root .db-chips{display:flex;justify-content:center;gap:8px;flex-wrap:wrap;margin:22px 0 6px}
#dima-bundle-root .db-chips span{display:inline-flex;align-items:center;gap:6px;background:var(--tint2);border:1px solid var(--line);border-radius:999px;padding:7px 14px;font-size:13px;font-weight:600;color:var(--navy)}
#dima-bundle-root .db-chips svg{width:15px;height:15px;flex:none}
#dima-bundle-root .db-ba{display:flex;gap:12px;margin:26px auto 8px;max-width:440px}
#dima-bundle-root .db-ba figure{flex:1;position:relative}
#dima-bundle-root .db-ba .db-ph{aspect-ratio:1/1;background:linear-gradient(160deg,#E9EDF5,#DDE4F0);border-radius:14px;display:flex;align-items:center;justify-content:center;color:#98A2B8;font-size:12px;font-weight:600;text-align:center;padding:8px;overflow:hidden}
#dima-bundle-root .db-ba .db-ph img{width:100%;height:100%;object-fit:cover;border-radius:14px}
#dima-bundle-root .db-ba figcaption{position:absolute;top:10px;left:10px;background:#fff;border-radius:999px;padding:5px 12px;font-size:12px;font-weight:700;color:var(--navy);box-shadow:0 2px 8px rgba(16,16,16,.12)}
#dima-bundle-root .db-ba .db-result-tag{position:absolute;bottom:10px;right:10px;background:var(--blue);color:#fff;border-radius:999px;padding:5px 12px;font-size:12px;font-weight:700}
#dima-bundle-root .db-fine{font-size:12px;color:#8a92a3;text-align:center;margin:8px 0 0}
#dima-bundle-root .db-statband{background:var(--tint);border:1px solid #D9E5FC;border-radius:16px;padding:26px 24px;margin:30px 0;display:flex;align-items:center;gap:20px}
#dima-bundle-root .db-statband b{font-size:clamp(38px,7vw,52px);font-weight:800;color:var(--blue);letter-spacing:-.02em;line-height:1;flex:none}
#dima-bundle-root .db-statband p{font-size:16px;line-height:1.45;color:#2b3240}
#dima-bundle-root .db-statband p strong{color:var(--navy)}
#dima-bundle-root .db-sec{margin:38px 0}
#dima-bundle-root .db-sec-label{letter-spacing:.14em;text-transform:uppercase;font-size:12px;font-weight:700;color:var(--grey);margin-bottom:14px}
#dima-bundle-root .db-prod{border:1.5px solid var(--line);border-radius:16px;padding:18px;margin-bottom:12px;cursor:pointer;transition:.15s;position:relative;background:#fff}
#dima-bundle-root .db-prod.selected{border-color:var(--blue);background:var(--tint)}
#dima-bundle-root .db-badge{position:absolute;top:-11px;right:14px;background:var(--green);color:#fff;font-size:11px;font-weight:800;letter-spacing:.06em;padding:5px 12px;border-radius:999px}
#dima-bundle-root .db-prod-top{display:flex;gap:14px;align-items:flex-start}
#dima-bundle-root .db-cb{width:26px;height:26px;border-radius:7px;border:2px solid #C9D2E3;flex:none;margin-top:2px;display:flex;align-items:center;justify-content:center;background:#fff}
#dima-bundle-root .db-prod.selected .db-cb{background:var(--blue);border-color:var(--blue)}
#dima-bundle-root .db-prod.selected .db-cb::after{content:"✓";color:#fff;font-weight:800;font-size:15px}
#dima-bundle-root .db-pimg{width:64px;height:64px;border-radius:10px;background:#fff;border:1px solid var(--line);flex:none;object-fit:cover;display:block}
#dima-bundle-root .db-prod-info{flex:1}
#dima-bundle-root .db-prod-info h3{font-size:18px;font-weight:800;color:var(--navy)}
#dima-bundle-root .db-prod-info .db-mech{color:var(--grey);font-size:14px;margin-top:2px}
#dima-bundle-root .db-price{text-align:right;flex:none}
#dima-bundle-root .db-price small{display:block;color:var(--grey);font-size:12px}
#dima-bundle-root .db-price b{font-size:20px;color:var(--navy)}
#dima-bundle-root .db-price b i{font-style:normal;font-size:13px;color:var(--grey);font-weight:500}
#dima-bundle-root .db-why{list-style:none;margin:12px 0 0 40px;display:flex;flex-direction:column;gap:6px}
#dima-bundle-root .db-why li{font-size:14px;color:#2b3240;position:relative;padding-left:24px}
#dima-bundle-root .db-why li::before{content:"✓";position:absolute;left:0;top:0;color:var(--blue);font-weight:800}
#dima-bundle-root .db-locknote{display:none;background:#FEF3E7;border:1px solid #F5CBA0;color:#9A5B13;border-radius:10px;padding:10px 14px;font-size:13.5px;margin:0 0 12px;line-height:1.45}
#dima-bundle-root .db-locknote.show{display:block}
#dima-bundle-root .db-combo{border:1.5px dashed var(--blue);background:var(--tint);border-radius:14px;padding:16px 18px;display:flex;align-items:center;gap:14px;margin-top:4px;cursor:pointer}
#dima-bundle-root .db-combo .db-pct{font-size:30px;font-weight:800;color:var(--blue);flex:none;letter-spacing:-.02em}
#dima-bundle-root .db-combo p{font-size:14px;line-height:1.45;color:#2b3240;flex:1}
#dima-bundle-root .db-combo p b{color:var(--navy)}
#dima-bundle-root .db-combo .db-shipgreen{color:var(--green);font-weight:700}
#dima-bundle-root .db-combo .db-add{flex:none;color:var(--blue);font-weight:800;font-size:16px;padding:6px 10px}
#dima-bundle-root .db-unlocked{border:1px solid #BBF7D0;background:var(--green-bg);border-radius:14px;padding:14px 16px;display:flex;align-items:center;gap:12px;margin-top:4px}
#dima-bundle-root .db-unlocked .db-cu{width:28px;height:28px;border-radius:50%;background:#BBF7D0;color:var(--green);display:flex;align-items:center;justify-content:center;flex:none;font-weight:800;font-size:15px}
#dima-bundle-root .db-unlocked p{font-size:14px;line-height:1.45;color:#2b3240}
#dima-bundle-root .db-unlocked p b{color:var(--green)}
#dima-bundle-root .db-supply-group{margin-bottom:22px}
#dima-bundle-root .db-supply-head{display:flex;align-items:baseline;gap:8px;margin:0 0 10px}
#dima-bundle-root .db-supply-head b{font-size:16px;font-weight:800;color:var(--navy)}
#dima-bundle-root .db-supply-head small{font-size:13px;color:var(--grey)}
#dima-bundle-root .db-cad{border:1.5px solid var(--line);border-radius:14px;padding:16px 18px;margin-bottom:10px;display:flex;align-items:center;gap:14px;cursor:pointer;position:relative;transition:.15s;background:#fff}
#dima-bundle-root .db-cad.selected{border-color:var(--blue);background:var(--tint)}
#dima-bundle-root .db-radio{width:22px;height:22px;border-radius:50%;border:2px solid #C9D2E3;flex:none;background:#fff}
#dima-bundle-root .db-cad.selected .db-radio{border:7px solid var(--blue)}
#dima-bundle-root .db-cad-info{flex:1}
#dima-bundle-root .db-cad-info b{font-size:17px;color:var(--navy)}
#dima-bundle-root .db-cad-info small{display:block;color:var(--grey);font-size:13px;margin-top:1px}
#dima-bundle-root .db-cprice{text-align:right}
#dima-bundle-root .db-cprice b{font-size:19px;color:var(--navy)}
#dima-bundle-root .db-cprice b i{font-style:normal;font-size:13px;color:var(--grey);font-weight:500}
#dima-bundle-root .db-cprice small{display:block;font-size:13px;color:var(--grey)}
#dima-bundle-root .db-cprice small s{color:#98A2B8}
#dima-bundle-root .db-tag{position:absolute;top:-11px;right:14px;font-size:11px;font-weight:800;letter-spacing:.06em;padding:5px 12px;border-radius:999px;background:var(--blue);color:#fff}
#dima-bundle-root .db-savepill{display:inline-block;background:var(--green-bg);color:var(--green);font-size:12px;font-weight:700;border-radius:6px;padding:3px 8px;margin-top:3px}
#dima-bundle-root .db-cadnote{font-size:13px;color:var(--grey);margin-top:10px;text-align:center}
#dima-bundle-root .db-shipbar{margin-top:16px}
#dima-bundle-root .db-shipbar p{font-size:13px;text-align:center;margin:0 0 6px;color:#2b3240}
#dima-bundle-root .db-shipbar p strong{color:var(--green)}
#dima-bundle-root .db-shiptrack{height:6px;background:var(--line);border-radius:999px;overflow:hidden}
#dima-bundle-root .db-shipfill{height:100%;background:var(--green);border-radius:999px;transition:width .3s}
#dima-bundle-root .db-summary{border:1px solid var(--line);border-radius:16px;padding:20px;margin-top:8px;background:#fff}
#dima-bundle-root .db-summary h3{font-size:18px;font-weight:800;color:var(--navy);margin-bottom:12px}
#dima-bundle-root .db-sumrow{display:flex;justify-content:space-between;padding:7px 0;font-size:15px;color:#2b3240}
#dima-bundle-root .db-sumrow.green{color:var(--green);font-weight:600}
#dima-bundle-root .db-sumrow.total{border-top:1px solid var(--line);margin-top:8px;padding-top:14px;font-size:18px;font-weight:800;color:var(--navy)}
#dima-bundle-root .db-perday{background:var(--tint);border-radius:10px;padding:10px 14px;margin-top:12px;display:flex;justify-content:space-between;font-size:14px;font-weight:700;color:var(--blue)}
#dima-bundle-root .db-bt{display:flex;gap:24px;align-items:center;background:var(--tint2);border:1px solid var(--line);border-radius:16px;padding:24px}
#dima-bundle-root .db-bt-img{flex:0 0 38%}
#dima-bundle-root .db-bt-img img{width:100%;border-radius:12px;display:block}
#dima-bundle-root .db-bt-copy .db-eyebrow{display:block;margin-bottom:8px}
#dima-bundle-root .db-bt-copy .db-sub{margin-top:8px}
@media (max-width:560px){#dima-bundle-root .db-bt{flex-direction:column}#dima-bundle-root .db-bt-img{flex:none;width:70%}}
#dima-bundle-root .db-steps{display:flex;flex-direction:column;margin-top:14px}
#dima-bundle-root .db-step{display:flex;gap:16px;padding:16px 0;border-bottom:1px solid var(--line)}
#dima-bundle-root .db-step:last-child{border-bottom:none}
#dima-bundle-root .db-step .db-n{width:34px;height:34px;border-radius:50%;background:var(--tint);color:var(--blue);font-weight:800;display:flex;align-items:center;justify-content:center;flex:none;font-size:15px}
#dima-bundle-root .db-step b{display:block;font-size:16px;color:var(--navy);margin-bottom:2px}
#dima-bundle-root .db-step p{font-size:14px;color:var(--grey);line-height:1.45}
#dima-bundle-root .db-urgency{background:var(--tint2);border:1px solid var(--line);border-radius:16px;padding:24px;margin:38px 0}
#dima-bundle-root .db-urgency h2{margin-bottom:8px}
#dima-bundle-root .db-urgency .db-sub{margin-bottom:18px}
#dima-bundle-root .db-timeline{display:flex;gap:8px;margin-bottom:14px}
#dima-bundle-root .db-tl{flex:1;text-align:center}
#dima-bundle-root .db-tl svg{width:100%;max-width:84px;height:auto;display:block;margin:0 auto 8px}
#dima-bundle-root .db-tl b{font-size:12px;color:var(--navy);display:block}
#dima-bundle-root .db-tl small{font-size:11px;color:var(--grey)}
#dima-bundle-root .db-kicker{font-size:15px;color:#2b3240;line-height:1.5}
#dima-bundle-root .db-kicker b{color:var(--blue)}
#dima-bundle-root .db-docs{display:flex;gap:10px;overflow-x:auto;padding-bottom:6px}
#dima-bundle-root .db-doc{flex:0 0 150px;border:1px solid var(--line);border-radius:14px;padding:14px;text-align:center;background:#fff}
#dima-bundle-root .db-doc img{width:52px;height:52px;border-radius:50%;object-fit:cover;object-position:top;margin:0 auto 10px;display:block;background:#E9EDF5}
#dima-bundle-root .db-doc b{font-size:13px;color:var(--navy);display:block;line-height:1.25}
#dima-bundle-root .db-doc small{font-size:11.5px;color:var(--grey);display:block;margin-top:3px}
#dima-bundle-root .db-prc{display:inline-block;margin-top:7px;font-size:10.5px;font-weight:700;color:var(--blue);background:var(--tint);border-radius:5px;padding:2px 7px}
#dima-bundle-root .db-stages{display:flex;gap:12px;overflow-x:auto;padding-bottom:6px;margin-top:16px}
#dima-bundle-root .db-stage{flex:0 0 340px;border:1px solid var(--line);border-radius:16px;padding:16px;background:#fff}
#dima-bundle-root .db-stage h3{font-size:18px;font-weight:800;color:var(--navy)}
#dima-bundle-root .db-hl,#dima-bundle-root .db-step b.db-hl{color:var(--blue)}
#dima-bundle-root .db-ssub{font-size:13.5px;color:var(--grey);margin:2px 0 12px}
#dima-bundle-root .db-verified{color:var(--blue);font-weight:700;font-size:12px;margin-left:4px}
#dima-bundle-root .db-simgs{display:flex;gap:8px}
#dima-bundle-root .db-simgs figure{flex:1;position:relative}
#dima-bundle-root .db-simgs img{width:100%;aspect-ratio:3/4;object-fit:cover;border-radius:10px;background:#E9EDF5;display:block}
#dima-bundle-root .db-simgs figcaption{position:absolute;top:8px;left:8px;background:#fff;border-radius:999px;padding:3px 9px;font-size:11px;font-weight:700;color:var(--navy);box-shadow:0 2px 6px rgba(16,16,16,.12)}
#dima-bundle-root .db-stagtags{display:grid;grid-template-columns:1fr 1fr;gap:6px;margin-top:12px}
#dima-bundle-root .db-stagtags span{background:var(--tint);color:var(--blue);font-size:12px;font-weight:600;border-radius:999px;padding:6px 10px;white-space:nowrap;text-align:center}
#dima-bundle-root .db-sfine{font-size:11px;color:#8a92a3;margin-top:12px;text-align:center;line-height:1.4}
#dima-bundle-root details{border-bottom:1px solid var(--line);padding:14px 0}
#dima-bundle-root details summary{font-weight:700;font-size:15px;color:var(--navy);cursor:pointer;list-style:none;display:flex;justify-content:space-between}
#dima-bundle-root details summary::after{content:"+";color:var(--blue);font-weight:600}
#dima-bundle-root details[open] summary::after{content:"−"}
#dima-bundle-root details p{margin-top:10px;font-size:14px;color:var(--grey);line-height:1.55}
#dima-bundle-root .db-sticky{position:fixed;bottom:0;left:0;right:0;background:#fff;border-top:1px solid var(--line);padding:12px 20px;box-shadow:0 -8px 24px rgba(16,22,40,.08);z-index:9999}
#dima-bundle-root .db-sticky-inner{max-width:680px;margin:0 auto;display:grid;grid-template-areas:"price" "button" "green";row-gap:10px}
#dima-bundle-root .db-sticky-price{grid-area:price;display:flex;align-items:baseline;justify-content:space-between}
#dima-bundle-root .db-sticky-price b{font-size:20px;font-weight:800;color:var(--navy);letter-spacing:-.01em}
#dima-bundle-root .db-sticky-price span{font-size:13.5px;color:var(--grey);font-weight:500}
#dima-bundle-root .db-green{grid-area:green;text-align:center;font-size:12.5px;font-weight:700;color:var(--green);margin:-2px 0 0}
#dima-bundle-root .db-sticky .db-cta{grid-area:button;width:100%;padding:15px;font-size:16px;box-shadow:0 4px 14px rgba(37,99,235,.28)}
@media (min-width:640px){
  #dima-bundle-root .db-sticky-inner{grid-template-areas:"price button" "green button";grid-template-columns:1fr auto;column-gap:24px;row-gap:3px;align-items:center}
  #dima-bundle-root .db-sticky-price{justify-content:flex-start;gap:10px}
  #dima-bundle-root .db-green{text-align:left}
  #dima-bundle-root .db-sticky .db-cta{width:auto;padding:15px 36px;align-self:center}
}
#dima-bundle-root .db-cta{flex:1;background:var(--blue);color:#fff;border:none;border-radius:12px;padding:16px;font-size:16px;font-weight:800;cursor:pointer;transition:.15s}
#dima-bundle-root .db-cta:hover{background:var(--blue-dark)}
#dima-bundle-root .db-cta:disabled{opacity:.4;cursor:not-allowed}
#dima-bundle-root .db-guarantee{text-align:center;font-size:12px;color:var(--grey);margin-top:8px}
#dima-bundle-root .db-ineligible{text-align:center;padding:40px 20px}
#dima-bundle-root .db-ineligible .db-icon{font-size:48px;margin-bottom:16px}
#dima-bundle-root .db-ineligible h1{font-size:22px;margin:0 0 12px}
#dima-bundle-root .db-ineligible p{font-size:14px;color:var(--grey);margin-bottom:24px;line-height:1.6}
#dima-bundle-root .db-ineligible a{color:var(--blue);font-weight:600;text-decoration:none}`;
  if (!document.getElementById("dima-v2-style")) document.head.appendChild(STYLE);

  /* ---------- CONFIG (mirrors live dima-bundle-results.js pricing) ---------- */
  var PRODUCTS = {
    finasteride: {
      name: "Finasteride 1mg", subtitle: "30 tablets/box · taken once daily",
      mech: "Stops hair loss at the root cause",
      why: ["Blocks DHT — the hormone that shrinks follicles", "Stops further hair loss in <b>97% of men</b>", "FDA-approved with 25+ years of clinical data"],
      img: "https://cdn.shopify.com/s/files/1/0757/9913/4489/files/Finasteride_Dima_1_feaa55bd-2f0f-4494-a242-144c9bc6bcf3.png?v=1713242045",
      variantId: 50864654352665, // Finasteride 1mg (ACTIVE). qty = months; Shopify auto-discounts 10% @3, 15% @6
      tiers: [
        { months: 1, boxes: 1, fullPrice: 1500, discount: 0,    price: 1500 },
        { months: 3, boxes: 3, fullPrice: 4500, discount: 0.10, price: 4050 },
        { months: 6, boxes: 6, fullPrice: 9000, discount: 0.15, price: 7650 }
      ]
    },
    minoxidil: {
      name: "Oral Minoxidil 2.5mg", subtitle: "30 capsules/bottle · taken once daily",
      mech: "Regrows thicker, fuller hair",
      why: ["Boosts blood flow to reactivate follicles", "Works through a different mechanism than Finasteride", "No messy topicals — one small tablet daily"],
      img: "https://cdn.shopify.com/s/files/1/0757/9913/4489/files/Website_Product_Image_Template_5.png?v=1749621816",
      variantId: 50899502989593, // Oral Minoxidil 2.5mg (ACTIVE). No active qty discount — matches our tier table
      /* Store purchase limit for Oral Minoxidil is 3 — a 3-month supply (qty 3)
         is the maximum that will pass /cart/add.js. Do not add a 6-month tier
         unless that limit is raised again. */
      tiers: [
        { months: 1, boxes: 1, fullPrice: 1500, discount: 0, price: 1500 },
        { months: 3, boxes: 3, fullPrice: 4500, discount: 0, price: 4500 }
      ]
    }
  };
  var FREE_SHIPPING_THRESHOLD = 2500, SHIPPING_COST = 100;
  /* Default supply per product: Finasteride opens on 3 months (its recommended
     tier), Oral Minoxidil opens on the 1-month bottle. */
  var DEFAULT_MONTHS = { finasteride: 3, minoxidil: 1 };

  /* Hero before/after: Today = the stage photo they picked, Month 3 = one stage prior.
     TODO: fill URLs when the Higgsfield stage set is uploaded to Shopify Files.
     null = grey placeholder box with the label shown. */
  /* Regrowth = the dedicated after-photo shown when they pick Just Starting. */
  /* Pinned to the correctly-named Shopify files. Do NOT rely on the quiz's own
     option images — two of those options currently point at the wrong (and one
     at a deleted) file. Filenames in Shopify are the source of truth. */
  var SCDN = "https://cdn.shopify.com/s/files/1/0757/9913/4489/files/";
  var STAGE_PHOTOS = {
    "Just Starting": SCDN + "quiz-filipino_juststarting.webp?v=1785310043",
    "Mild":          SCDN + "quiz-filipino_mild.webp?v=1785308170",
    "Moderate":      SCDN + "quiz-filipino_moderate.webp?v=1785310056",
    "Advanced":      SCDN + "quiz-filipino_advanced.webp?v=1785308174",
    "Regrowth":      SCDN + "quiz-preserve.png?v=1785308263"
  };
  var STAGE_PRIOR  = { "Just Starting": "Regrowth", "Mild": "Just Starting", "Moderate": "Mild", "Advanced": "Moderate" };

  var DOCTORS = [
    { n: "Dr. Rhea Katrina Salomon", s: "General Practice", img: "https://cdn.shopify.com/s/files/1/0757/9913/4489/files/Dr._Rhea_Salomon.png" },
    { n: "Dr. Deano Reyes", s: "Gender and Sexual Health", img: "https://cdn.shopify.com/s/files/1/0757/9913/4489/files/doc_deano.jpg" },
    { n: "Dr. Patrick Paolo Abarquez", s: "Internal Medicine · Endocrinology", img: "https://cdn.shopify.com/s/files/1/0757/9913/4489/files/Dr._Patrick_Abarquez.png" },
    { n: "Dr. Ame Lopez", s: "General Practice", img: "https://cdn.shopify.com/s/files/1/0757/9913/4489/files/Ame-Lopez.webp" },
    { n: "Dr. Thaddeus Averilla", s: "Internal Medicine", img: "https://cdn.shopify.com/s/files/1/0757/9913/4489/files/Dr._Thaddy.jpg" },
    { n: "Dr. Bernadette Yap Abela", s: "General Practice", img: "https://cdn.shopify.com/s/files/1/0757/9913/4489/files/bernadette-yap.jpg" }
  ];
  /* Stage gallery — Keeps' four stages verbatim, DIMA model pairs. */
  var CDN = "https://cdn.shopify.com/s/files/1/0757/9913/4489/files/";
  var STAGES_GALLERY = [
    /* Naming: ob<N> = BEFORE, oa<N> = AFTER, N = the model index (same person). */
    { t: "Preservation",          s: "Getting ahead of it.",               b: CDN + "dima_stage_ob1.png?v=1785411633", a: CDN + "dima_stage_oa1.png?v=1785411403", tags: ["Mild Crown Loss", "Family History", "Want to Keep It"] },
    { t: "Early hair loss",       s: "Starting to notice subtle changes.", b: CDN + "dima_stage_ob2.png?v=1785411403", a: CDN + "dima_stage_oa2.png?v=1785411403", tags: ["Hairline Receding", "Temples Thinning", "More Shedding"] },
    { t: "Progressive hair loss", s: "Hard to ignore now.",                b: CDN + "dima_stage_ob3.png?v=1785411403", a: CDN + "dima_stage_oa3.png?v=1785411403", tags: ["Crown Thinning", "Scalp Showing", "Less Density"] },
    { t: "Advanced loss",         s: "Widespread, noticeable loss.",       b: CDN + "dima_stage_ob4.png?v=1785411403", a: CDN + "dima_stage_oa4.png?v=1785411403", tags: ["Hairline + Crown Loss", "Scalp Visible", "Past Treatments Failed"] }
  ];

  /* ---------- QUIZ DATA ----------
     Keeps of HAIR quiz block refs:
       Gender  ("Which best describes you?")             = qbc-89d0f3fa
       Pregnancy ("Currently pregnant or breastfeeding?") = qbc-1e16dfab
     Value-string matching kept as fallback in case refs change. */
  var GENDER_BLOCK = "qbc-89d0f3fa", PREGNANCY_BLOCK = "qbc-1e16dfab", AGE_BLOCK = "qbc-920db48f"; // "Are you over 18 years old?" Yes/No

  /* --- Klaviyo: signals that this person reached the results page. Without it
     Klaviyo cannot tell quiz completers from abandoners — both fire the same
     New Lead event at Q1 and RevenueHunt leaves the result fields empty. --- */
  var KLAVIYO_RESULTS_TRACKED = false;
  function quizEmailFromAnswers() {
    try {
      var A = (typeof quiz !== "undefined" && quiz.answers) ? quiz.answers
            : ((typeof Quiz !== "undefined" && Quiz.answers) ? Quiz.answers : null);
      var answers = A ? (Array.isArray(A) ? A : (A.list || [])) : [];
      for (var i = 0; i < answers.length; i++) {
        var v = String(answers[i].value || "").trim();
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return v;
      }
    } catch (e) {}
    return null;
  }
  function trackQuizResultsViewed(eligible) {
    if (KLAVIYO_RESULTS_TRACKED) return;
    var email = quizEmailFromAnswers(), tries = 0;
    (function push() {
      if (!window._learnq) { if (tries++ < 20) setTimeout(push, 250); return; }
      KLAVIYO_RESULTS_TRACKED = true;
      try {
        if (email) window._learnq.push(["identify", { $email: email }]);
        window._learnq.push(["track", "Viewed Quiz Results", {
          quiz: "keeps of HAIR", quiz_id: "4G2AYC",
          stage: (typeof quizData !== "undefined" && quizData.stage) || null,
          sex: (typeof quizData !== "undefined" && quizData.sex) || null,
          eligible: !!eligible
        }]);
      } catch (e) {}
    })();
  }

  function getQuizData() {
    var sex = "male", pregnant = false, stage = "Mild", underage = false;
    try {
      // quiz.answers is an OBJECT: { list:[...], byBlock:{...}, byQuestion:{...} }
      var A = (typeof quiz !== "undefined" && quiz.answers) ? quiz.answers : ((typeof Quiz !== "undefined" && Quiz.answers) ? Quiz.answers : null);
      var answers = A ? (Array.isArray(A) ? A : (A.list || [])) : [];
      var stageByLower = {};
      Object.keys(STAGE_PRIOR).forEach(function(k){ stageByLower[k.toLowerCase()] = k; });
      for (var i = 0; i < answers.length; i++) {
        var a = answers[i];
        var ref = String(a.blockRef || "");
        var val = String(a.value || "").trim();
        if (ref === GENDER_BLOCK && val) {
          // values are "Male at birth" / "Female at birth" — test female first ("male" is a substring)
          sex = /female/i.test(val) ? "female" : (/male/i.test(val) ? "male" : sex);
        } else if (/^(male|female)( at birth)?$/i.test(val)) {
          sex = /^female/i.test(val) ? "female" : "male";
        }
        if (ref === AGE_BLOCK && val) { underage = /^no$/i.test(val); }
        if (ref === PREGNANCY_BLOCK) {
          if (/pregnant|breastfeed/i.test(val)) { pregnant = true; }
        } else if (/^(pregnant|breastfeeding)$/i.test(val)) { pregnant = true; }
        if (val && stageByLower[val.toLowerCase()]) { stage = stageByLower[val.toLowerCase()]; }
      }
    } catch(e) { console.warn("[DIMA Results] Could not read quiz answers:", e); }
    return { sex: sex, pregnant: pregnant, stage: stage, underage: underage };
  }

  /* Pull the stage photos straight from the quiz's picture-choice question
     (qbc-3caf1a75) so the hero pair always matches what's uploaded in the
     builder. "Regrowth" has no quiz option — stays placeholder until a
     dedicated image URL is set in STAGE_PHOTOS above. */
  function loadStagePhotosFromQuiz() {
    try {
      (quiz.questions || []).forEach(function(q) {
        (q.blocks || []).forEach(function(b) {
          if (b.ref === "qbc-3caf1a75" && b.preferences && b.preferences.choices) {
            b.preferences.choices.forEach(function(c) {
              if (c.label && c.imageUrl && Object.prototype.hasOwnProperty.call(STAGE_PHOTOS, c.label) && !STAGE_PHOTOS[c.label]) {
                STAGE_PHOTOS[c.label] = c.imageUrl;
              }
            });
          }
        });
      });
    } catch(e) { console.warn("[DIMA Results] Could not load stage photos:", e); }
  }

  var quizData = { sex: "male", pregnant: false, stage: "Mild", underage: false };
  var state = { selected: {}, tiers: {} };

  function availableProducts() { return quizData.sex === "female" ? ["minoxidil"] : ["finasteride", "minoxidil"]; }
  function selectedProducts() { return Object.keys(state.selected).filter(function(k){ return state.selected[k]; }); }
  function peso(n) { return "₱" + n.toLocaleString("en-PH"); }
  function perDay(price, months) { return Math.round(price / (months * 30)); }
  function tierOf(key) { var m = state.tiers[key] || DEFAULT_MONTHS[key]; return PRODUCTS[key].tiers.filter(function(t){ return t.months === m; })[0]; }

  function calc() {
    var subtotal = 0, fullTotal = 0, items = [], combinedPerDay = 0;
    selectedProducts().forEach(function(key) {
      var t = tierOf(key);
      subtotal += t.price; fullTotal += t.fullPrice;
      combinedPerDay += perDay(t.price, t.months);
      items.push({ name: PRODUCTS[key].name, months: t.months, price: t.price });
    });
    var supplyDiscount = fullTotal - subtotal;
    var freeShip = subtotal >= FREE_SHIPPING_THRESHOLD;
    return { subtotal: subtotal, supplyDiscount: supplyDiscount, freeShip: freeShip,
      shipping: freeShip ? 0 : SHIPPING_COST, totalSaved: supplyDiscount /* discount only — free shipping is stated separately */,
      total: subtotal + (freeShip ? 0 : SHIPPING_COST), items: items, combinedPerDay: combinedPerDay };
  }

  /* ---------- RENDER ---------- */
  function headSvg(stageIdx) {
    var base = '<ellipse cx="13" cy="36" rx="3.5" ry="6" fill="#DCE3F0"/><ellipse cx="51" cy="36" rx="3.5" ry="6" fill="#DCE3F0"/><ellipse cx="32" cy="35" rx="18" ry="23" fill="#2563EB"/>';
    var id = "dbtl" + stageIdx;
    var clip = '<clipPath id="' + id + '"><ellipse cx="32" cy="35" rx="18" ry="23"/></clipPath>';
    var scalp = "";
    if (stageIdx === 1) scalp = '<circle cx="32" cy="44" r="2" fill="#DCE3F0"/>';
    if (stageIdx === 2) scalp = '<g fill="#DCE3F0"><circle cx="32" cy="44" r="5.5"/><circle cx="21" cy="15" r="4.5"/><circle cx="43" cy="15" r="4.5"/></g>';
    if (stageIdx === 3) scalp = '<g fill="#DCE3F0"><circle cx="32" cy="42" r="8"/><circle cx="21" cy="16" r="6"/><circle cx="43" cy="16" r="6"/><circle cx="26" cy="21" r="1.1"/><circle cx="31" cy="19" r="1"/><circle cx="37" cy="20" r="1.2"/><circle cx="24" cy="26" r="1"/><circle cx="29" cy="24" r="1.3"/><circle cx="34" cy="23" r="1"/><circle cx="39" cy="25" r="1.1"/><circle cx="26" cy="30" r="1.2"/><circle cx="31" cy="28" r="1"/><circle cx="36" cy="29" r="1.3"/><circle cx="41" cy="30" r="1"/><circle cx="28" cy="33" r="1"/><circle cx="33" cy="32" r="1.2"/><circle cx="38" cy="33" r="1"/></g>';
    if (stageIdx === 4) scalp = '<g fill="#DCE3F0"><ellipse cx="32" cy="29" rx="14" ry="20"/></g>';
    return '<svg viewBox="0 0 64 68">' + base + clip + '<g clip-path="url(#' + id + ')">' + scalp + "</g></svg>";
  }

  function phBox(stage) {
    var url = STAGE_PHOTOS[stage];
    if (url) return '<img src="' + url + '" alt="' + stage + '">';
    return "[ " + stage + " — stage photo ]";
  }

  function renderHero() {
    var today = quizData.stage, after = STAGE_PRIOR[quizData.stage];
    return '<div class="db-hero"><div class="db-check">✓</div>' +
      '<span class="db-eyebrow">Doctor-Reviewed Treatment Plan</span>' +
      "<h1>Good news — you're approved.</h1>" +
      '<p class="db-sub">We\'ve matched your hair loss profile to a treatment plan proven to deliver visible results in as little as 3 months.</p>' +
      '<div class="db-chips">' + ["FDA-approved", "PRC-licensed doctors", "Discreet delivery"].map(function(t) {
        return '<span><svg viewBox="0 0 24 24" fill="none" stroke="#2563EB" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9 12l2 2 4-4"/></svg>' + t + "</span>";
      }).join("") + "</div></div>" +
      '<div class="db-sec"><div class="db-ba">' +
      '<figure><div class="db-ph">' + phBox(today) + "</div><figcaption>Today</figcaption></figure>" +
      '<figure><div class="db-ph">' + phBox(after) + '</div><figcaption>Month 3*</figcaption><span class="db-result-tag">Visible Regrowth</span></figure>' +
      '</div><p class="db-fine">*Results vary by individual. Timelines depend on hair loss stage, adherence, and biological response.</p></div>';
  }

  function renderStatband() {
    if (quizData.sex === "female") return "";
    return '<div class="db-statband"><b>97%</b><p>of patients <strong>stop further hair loss</strong> with doctor-reviewed treatment that targets the root cause.</p></div>';
  }

  function renderProducts() {
    var html = '<div class="db-sec"><div class="db-sec-label">Your recommended treatments</div>';
    availableProducts().forEach(function(key) {
      var p = PRODUCTS[key];
      var minDaily = Math.min.apply(null, p.tiers.map(function(t){ return perDay(t.price, t.months); }));
      html += '<div class="db-prod' + (state.selected[key] ? " selected" : "") + '" data-toggle="' + key + '">' +
        '<span class="db-badge">APPROVED FOR YOU</span><div class="db-prod-top">' +
        '<div class="db-cb"></div><img class="db-pimg" src="' + p.img + '" alt="' + p.name + '">' +
        '<div class="db-prod-info"><h3>' + p.name + '</h3><div class="db-mech">' + p.mech + "</div></div>" +
        '<div class="db-price"><small>from</small><b>' + peso(minDaily) + "<i>/day</i></b></div></div>" +
        '<ul class="db-why">' + p.why.map(function(w){ return "<li>" + w + "</li>"; }).join("") + "</ul></div>";
      if (key === "finasteride") {
        html += '<div class="db-locknote" id="db-locknote">For male pattern hair loss, Finasteride is the foundation of every DIMA plan — it\'s the treatment that blocks DHT, the root cause. Our doctors prescribe Oral Minoxidil for men as a regrowth booster alongside it, not in place of it.</div>';
      }
    });
    // combo banner / unlocked (male path only — needs both products available)
    if (availableProducts().length === 2) {
      if (selectedProducts().length === 2) {
        html += '<div class="db-unlocked"><div class="db-cu">✓</div><p><b>Dual-action bundle!</b> Combining both is clinically proven to deliver the best results. <b>Free shipping if you bundle both!</b></p></div>';
      } else {
        html += '<div class="db-combo" data-toggle="minoxidil"><div class="db-pct">94%</div>' +
          '<p><b>Better together.</b> Finasteride stops the loss, Minoxidil drives the regrowth. Add both for the dual-action combo + <span class="db-shipgreen">free shipping</span>.</p>' +
          '<div class="db-add">+ Add</div></div>';
      }
    }
    return html + "</div>";
  }

  function renderSupply() {
    var html = '<div class="db-sec"><div class="db-sec-label">Choose your supply</div>';
    selectedProducts().forEach(function(key) {
      var p = PRODUCTS[key];
      html += '<div class="db-supply-group"><div class="db-supply-head"><b>' + p.name + "</b><small>" + p.subtitle + "</small></div>";
      var unit = key === "minoxidil" ? "bottle" : "box";
      p.tiers.forEach(function(t) {
        var sel = (state.tiers[key] || DEFAULT_MONTHS[key]) === t.months;
        var badge = "";
        if (t.months === 6) badge = '<span class="db-tag">BEST VALUE</span>';
        else if (t.months === 3 && key !== "minoxidil") badge = '<span class="db-tag">RECOMMENDED</span>';
        html += '<div class="db-cad' + (sel ? " selected" : "") + '" data-product="' + key + '" data-months="' + t.months + '">' + badge +
          '<div class="db-radio"></div><div class="db-cad-info"><b>' + t.months + " month" + (t.months > 1 ? "s" : "") + "</b><small>" + t.boxes + " " + unit + (t.boxes > 1 ? "s" : "") + "</small></div>" +
          '<div class="db-cprice"><b>' + peso(perDay(t.price, t.months)) + "<i>/day</i></b><small>" +
          (t.discount > 0 ? "<s>" + peso(t.fullPrice) + "</s> " : "") + peso(t.price) + "</small>" +
          (t.discount > 0 ? '<span class="db-savepill">Save ' + (t.discount * 100) + "%</span>" : "") + "</div></div>";
      });
      html += "</div>";
    });
    html += '<p class="db-cadnote">Most members choose 3 months — visible results typically begin around month 3.</p>';
    // shipping bar
    var c = calc(), text;
    if (c.freeShip) text = "<strong>You qualify for free shipping!</strong>";
    else if (availableProducts().length === 1) text = "<strong>Order a 3-month supply for free shipping</strong>";
    else if (selectedProducts().length < 2) text = "<strong>Bundle both medications for free shipping</strong>";
    else text = "Add <strong>" + peso(Math.max(FREE_SHIPPING_THRESHOLD - c.subtotal, 0)) + "</strong> more for free shipping";
    var pct = Math.min(Math.round(c.subtotal / FREE_SHIPPING_THRESHOLD * 100), 100);
    html += '<div class="db-shipbar"><p>' + text + '</p><div class="db-shiptrack"><div class="db-shipfill" style="width:' + pct + '%"></div></div></div>';
    return html + "</div>";
  }

  function renderSummary() {
    var c = calc();
    var html = '<div class="db-sec"><div class="db-summary"><h3>Order Summary</h3>';
    c.items.forEach(function(it) {
      html += '<div class="db-sumrow"><span>' + it.name + " · " + it.months + "mo</span><span>" + peso(it.price) + "</span></div>";
    });
    if (c.supplyDiscount > 0) html += '<div class="db-sumrow"><span>Multi-month discount</span><span>−' + peso(c.supplyDiscount) + "</span></div>";
    html += '<div class="db-sumrow' + (c.freeShip ? " green" : "") + '"><span>Shipping</span><span>' + (c.freeShip ? "FREE" : peso(c.shipping)) + "</span></div>";
    if (c.totalSaved > 0) html += '<div class="db-sumrow green"><span>You save</span><span>−' + peso(c.totalSaved) + "</span></div>";
    html += '<div class="db-sumrow total"><span>Total</span><span>' + peso(c.total) + "</span></div>";
    html += '<div class="db-perday"><span>That\'s only</span><span>' + peso(c.combinedPerDay) + "/day for your treatment</span></div></div></div>";
    return html;
  }

  function renderBetterTogether() {
    if (quizData.sex === "female") return "";
    return '<div class="db-sec db-bt"><div class="db-bt-img"><img src="https://cdn.shopify.com/s/files/1/0757/9913/4489/files/combo_image.png" alt="How Finasteride and Minoxidil work together"></div>' +
      '<div class="db-bt-copy"><span class="db-eyebrow">Better Together</span><h2>Why choose one when both work better?</h2>' +
      '<p class="db-sub">Finasteride stops hair loss at the root cause. Oral Minoxidil stimulates new growth. Together, they deliver results that neither can achieve alone.</p></div></div>';
  }

  function renderSteps() {
    var step1 = quizData.sex === "female"
      ? "Oral Minoxidil — matched to your goal by our medical team. No clinic visit needed."
      : "Finasteride, or Finasteride + Minoxidil — matched to your goal by our medical team. No clinic visit needed.";
    return '<div class="db-sec"><h2>What happens next</h2><div class="db-steps">' +
      '<div class="db-step"><div class="db-n">1</div><div><b class="db-hl">Pick your plan</b><p>' + step1 + "</p></div></div>" +
      '<div class="db-step"><div class="db-n">2</div><div><b class="db-hl">Delivered discreetly to your door</b><p>Plain, unbranded packaging. Free shipping on combo and multi-month plans.</p></div></div>' +
      '<div class="db-step"><div class="db-n">3</div><div><b class="db-hl">Watch it work</b><p>Most patients see visible regrowth by month 3, with full results at 9–12 months. Consistency is everything.</p></div></div></div></div>';
  }

  function renderUrgency() {
    return '<div class="db-urgency"><h2>Hair loss doesn\'t wait.</h2>' +
      '<p class="db-sub">Hair loss is progressive — untreated, follicles keep shrinking until they stop producing hair entirely. Dormant follicles are far harder to revive than active ones.</p>' +
      '<div class="db-timeline">' +
      '<div class="db-tl">' + headSvg(1) + "<b>Today</b><small>Start now</small></div>" +
      '<div class="db-tl">' + headSvg(2) + "<b>+6 months</b><small>untreated</small></div>" +
      '<div class="db-tl">' + headSvg(3) + "<b>+1 year</b><small>untreated</small></div>" +
      '<div class="db-tl">' + headSvg(4) + "<b>+2 years</b><small>untreated</small></div></div>" +
      '<p class="db-kicker"><b>The hair you have today is the easiest hair to save.</b> Every month of treatment protects the follicles you still have — starting now means keeping more.</p></div>';
  }

  function renderDoctors() {
    return '<div class="db-sec"><h2>Reviewed by <span class="db-hl">real doctors</span></h2><p class="db-sub" style="margin:8px 0 16px">Every plan is reviewed by a licensed Philippine physician before it ships.</p><div class="db-docs">' +
      DOCTORS.map(function(d) {
        return '<div class="db-doc"><img src="' + d.img + '" alt=""><b>' + d.n + "</b><small>" + d.s + '</small><span class="db-prc">PRC Licensed</span></div>';
      }).join("") + "</div></div>";
  }

  function renderStageGallery() {
    return '<div class="db-sec"><h2>Real results for <span class="db-hl">any stage</span></h2><div class="db-stages">' +
      STAGES_GALLERY.map(function(s) {
        return '<div class="db-stage"><h3>' + s.t + '</h3><p class="db-ssub">' + s.s + '</p><div class="db-simgs">' +
          "<figure><img src=\"" + s.b + "\" alt=\"Before treatment\"><figcaption>Month 0</figcaption></figure>" +
          "<figure><img src=\"" + s.a + "\" alt=\"After treatment\"><figcaption>Month 6</figcaption></figure></div>" +
          '<div class="db-stagtags">' + s.tags.map(function(t){ return "<span>" + t + "</span>"; }).join("") + "</div>" +
          '<p class="db-sfine">Images represent common hair loss patterns. Individual results vary.</p></div>';
      }).join("") + "</div></div>";
  }

  function renderFAQ() {
    return '<div class="db-sec"><h2>Common questions</h2><div style="margin-top:8px">' +
      "<details><summary>Is this safe?</summary><p>Finasteride has been FDA-approved for over 25 years with extensive clinical data. Oral Minoxidil is compounded by an FDA-registered pharmacy. Every plan is reviewed by a licensed Philippine physician who considers your medical history first.</p></details>" +
      "<details><summary>When will I see results?</summary><p>Many patients see visible regrowth as early as month 3, with full results at 9–12 months. Hair growth is gradual — we recommend at least 6 months before evaluating progress.</p></details>" +
      "<details><summary>What if I stop treatment?</summary><p>Hair loss is progressive — if you stop, benefits gradually reverse as the underlying process resumes. Most patients continue long-term, which is why plans start at just ₱43/day.</p></details>" +
      "<details><summary>Do I need an existing prescription?</summary><p>No. Your assessment is reviewed by a licensed physician who handles the prescription as part of the service. 100% online, no clinic visit.</p></details>" +
      "</div></div>";
  }

  function renderSticky() {
    var c = calc();
    // green line: savings and/or free shipping, joined with "+". Hidden when neither applies.
    var bits = [];
    if (c.totalSaved > 0) bits.push("You save " + peso(c.totalSaved));
    if (c.freeShip) bits.push("Free shipping");
    var green = bits.length ? '<p class="db-green">' + bits.join(" + ") + "</p>" : "";
    return '<div class="db-sticky"><div class="db-sticky-inner">' +
      '<div class="db-sticky-price"><b>' + peso(c.total) + '</b><span>' + peso(c.combinedPerDay) + "/day</span></div>" +
      '<button class="db-cta" id="db-checkout-btn">Start My Treatment →</button>' +
      green +
      "</div></div>";
  }

  function renderBlocked(body) {
    return '<div class="db-ineligible"><div class="db-icon">💙</div><h1>We Care About Your Safety</h1>' +
      "<p>" + body + "</p>" +
      '<a href="/">Return to DIMA</a></div>';
  }
  var BLOCK_PREGNANCY = "Based on your answers, our hair treatments aren't recommended during pregnancy or breastfeeding. Please consult your doctor for safe alternatives.";
  var BLOCK_UNDERAGE  = "Our treatments are prescription medications available only to adults 18 and older. Please check back once you turn 18 — and in the meantime, talk to your doctor about options that are right for you.";

  function render() {
    var root = document.getElementById("dima-bundle-root");
    if (!root) return;
    hideDefaultResults();
    if (quizData.underage) {
      root.innerHTML = renderHeader() + renderBlocked(BLOCK_UNDERAGE);
      attachRetake(root);
      trackQuizResultsViewed(false);
      return;
    }
    if (quizData.sex === "female" && quizData.pregnant) {
      root.innerHTML = renderHeader() + renderBlocked(BLOCK_PREGNANCY);
      attachRetake(root);
      trackQuizResultsViewed(false);
      return;
    }
    root.innerHTML =
      renderHeader() +
      renderHero() + renderStatband() + renderProducts() + renderSupply() + renderSummary() +
      renderBetterTogether() + renderSteps() + renderUrgency() + renderDoctors() +
      renderStageGallery() + renderFAQ() + renderSticky();
    attachListeners();
    trackQuizResultsViewed(true);
  }

  function attachListeners() {
    var root = document.getElementById("dima-bundle-root");
    root.querySelectorAll("[data-toggle]").forEach(function(el) {
      el.addEventListener("click", function() {
        var key = el.getAttribute("data-toggle");
        // LOCK: Finasteride can't be removed on the male path
        if (key === "finasteride" && quizData.sex === "male" && state.selected.finasteride && el.classList.contains("db-prod")) {
          var note = document.getElementById("db-locknote");
          if (note) {
            note.classList.add("show");
            clearTimeout(note._t);
            note._t = setTimeout(function(){ note.classList.remove("show"); }, 8000);
          }
          return;
        }
        if (el.classList.contains("db-combo")) { state.selected[key] = true; }
        else {
          if (state.selected[key] && selectedProducts().length === 1) return; // keep at least one
          state.selected[key] = !state.selected[key];
        }
        render();
      });
    });
    root.querySelectorAll(".db-cad").forEach(function(c) {
      c.addEventListener("click", function() {
        state.tiers[c.getAttribute("data-product")] = parseInt(c.getAttribute("data-months"), 10);
        render();
      });
    });
    attachRetake(root);
    var btn = document.getElementById("db-checkout-btn");
    if (btn) btn.addEventListener("click", addToCart);
  }

  function addToCart() {
    var btn = document.getElementById("db-checkout-btn");
    if (btn) { btn.textContent = "Adding to cart..."; btn.disabled = true; }
    var items = selectedProducts().map(function(key) {
      var months = state.tiers[key] || DEFAULT_MONTHS[key];
      return { id: PRODUCTS[key].variantId, quantity: months };
    });
    fetch("/cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json" } })
      .then(function() {
        return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: items }) });
      })
      .then(function(res) {
        if (!res.ok) {
          // fetch does NOT throw on 4xx — without this we would redirect to an empty checkout
          return res.json().then(function(e) { throw new Error(e.description || e.message || ("cart/add " + res.status)); });
        }
        return res.json();
      })
      .then(function() { window.location.href = "/checkout"; })
      .catch(function(err) {
        console.error("[DIMA Results] Cart error:", err);
        if (btn) { btn.textContent = (err && err.message) ? String(err.message).slice(0, 80) : "Something went wrong — try again"; btn.disabled = false; }
      });
  }

  function hideDefaultResults() {
    [".rh-results-content", ".rh-results-slots", "[class*=ResultsPage] > div", "[class*=results-page] > div", "[class*=result-page] > div"].forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        if (el.id !== "dima-bundle-root" && !el.contains(document.getElementById("dima-bundle-root"))) el.style.display = "none";
      });
    });
  }

  function injectRoot() {
    var root = document.getElementById("dima-bundle-root");
    if (root) return root;
    root = document.createElement("div");
    root.id = "dima-bundle-root";
    document.body.appendChild(root);
    return root;
  }

  function showQuizRenderer() {
    var qr = document.querySelector("[id*='revenuehunt'] quiz-renderer");
    if (qr) { qr.style.display = ""; qr.classList.add("dima-show-quiz"); }
  }

  function hideQuizRenderer() {
    var qr = document.querySelector("[id*='revenuehunt'] quiz-renderer");
    if (qr) { qr.style.display = "none"; qr.classList.remove("dima-show-quiz"); }
  }

  function isResultsMode() {
    try {
      if (typeof quiz !== "undefined" && (quiz.mode === "results" || quiz.mode === "result")) return true;
    } catch(e) {}
    return false;
  }

  var initialized = false;
  function init() {
    if (initialized) return;
    initialized = true;
    injectRoot();
    hideQuizRenderer();
    quizData = getQuizData();
    loadStagePhotosFromQuiz();
    availableProducts().forEach(function(p) {
      state.tiers[p] = DEFAULT_MONTHS[p];
      state.selected[p] = quizData.sex === "female" ? (p === "minoxidil") : (p === "finasteride");
    });
    render();
    var root = document.getElementById("dima-bundle-root");
    if (root) root.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function tryInit() {
    if (isResultsMode()) { init(); return; }
    var quizShown = false, pollCount = 0;
    var pollInterval = setInterval(function() {
      pollCount++;
      if (initialized || pollCount > 600) { clearInterval(pollInterval); return; }
      if (isResultsMode()) { clearInterval(pollInterval); init(); return; }
      if (!quizShown) {
        try { if (typeof quiz !== "undefined") { quizShown = true; showQuizRenderer(); } } catch(e) {}
      }
    }, 500);
  }

  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", tryInit); }
  else { tryInit(); }
})();
